module.exports = __webpack_public_path__ + "static/img/articlework1.2e2979c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlework1.jpg
// module id = YTOu
// module chunks = 1